module.exports = __webpack_public_path__ + "sample-shoe2.d6aaefc096cbb2e3eb5145abc8c062af.png";